import Icon from'@/components/ui/AppIcon';

const SocialProofSection = () => {
  return (
    <section className="py-24 bg-background">
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <div className="reveal">
          {/* Icon */}
          <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
            <Icon name="ShareIcon" size={40} className="text-primary" />
          </div>

          {/* Headline */}
          <h2 className="text-4xl md:text-5xl font-bold font-montserrat text-foreground mb-6">
            Follow Our Journey
          </h2>

          {/* Description */}
          <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
            See our latest projects, customer success stories, and behind-the-scenes content on Facebook.
          </p>

          {/* Facebook CTA */}
          <a
            href="https://www.facebook.com/profile.php?id=61584468262381"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-primary text-primary-foreground font-semibold rounded-full px-8 py-4 hover:bg-primary/90 transition-all hover:scale-105 shadow-lg"
          >
            <Icon name="ShareIcon" size={24} />
            Follow Containers by Take A Zip
          </a>

          {/* Social Stats */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-12 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Icon name="UserGroupIcon" size={20} className="text-primary" />
              <span>Join Our Community</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="PhotoIcon" size={20} className="text-primary" />
              <span>See Completed Projects</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="ChatBubbleLeftIcon" size={20} className="text-primary" />
              <span>Read Customer Reviews</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SocialProofSection